import { createStore as createReduxStore } from "redux";
import { initialState, reducer } from "./reducer";

export const createStore = stage =>
  createReduxStore(reducer, { ...initialState, stage });
